var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('big-file',{attrs:{"input-id":_vm.inputId,"text":_vm.text,"suffixs":_vm.suffixs,"use":_vm.use,"after-upload":_vm.afterUpload,"shard-size":1000 * 1024 * 1024,"url":'vod'}})}
var staticRenderFns = []

export { render, staticRenderFns }